module.exports = __webpack_public_path__ + "ab2.no1.db3ccfed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ab2.no1.jpg
// module id = +eg2
// module chunks = 0